import React from 'react'
import { MdKeyboardArrowRight } from "react-icons/md";
import Frame1 from '../../../Assets/Images/Frame-1.png';
import Frame2 from '../../../Assets/Images/Frame-2.png';
import Frame3 from '../../../Assets/Images/Frame-3.png';



const AddContentModal = () => {
  return (
    <div>
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">Add New Content</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div className='mb-5'>
                <div className="d-flex justify-content-between py-3 border-bottom">
                  <div>
                    <img src={Frame1} alt="" />
                    <span className='ps-3'>Input </span>
                  </div>
                  <div className='fs-3'>
                    <MdKeyboardArrowRight />
                  </div>
                </div>
                <div className="d-flex justify-content-between py-3 border-bottom">
                  <div>
                    <img src={Frame2} alt="" />
                    <span className='ps-3'>Products </span>
                  </div>
                  <div className='fs-3'>
                    <MdKeyboardArrowRight />
                  </div>
                </div>
                <div className="d-flex justify-content-between py-3 border-bottom">
                  <div>
                    <img src={Frame3} alt="" />
                    <span className='ps-3'>Files </span>
                  </div>
                  <div className='fs-3'>
                    <MdKeyboardArrowRight />
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddContentModal